// Custom Color Swatch JavaScript for Dawn Theme
// This script adds data-color attributes to color option labels

document.addEventListener('DOMContentLoaded', function() {
  // Find all product form inputs
  const colorInputs = document.querySelectorAll('.product-form__input input[type="radio"]');
  
  colorInputs.forEach(function(input) {
    const label = input.nextElementSibling;
    if (label && label.tagName === 'LABEL') {
      // Get the color name from the label text
      const colorName = label.textContent.trim();
      
      // Check if this is likely a color option (you can adjust this logic)
      const parentFieldset = input.closest('fieldset');
      const legend = parentFieldset ? parentFieldset.querySelector('legend') : null;
      const isColorOption = legend && (
        legend.textContent.toLowerCase().includes('color') ||
        legend.textContent.toLowerCase().includes('colour')
      );
      
      if (isColorOption && colorName) {
        // Add data-color attribute to the label
        label.setAttribute('data-color', colorName);
      }
    }
  });
});

// Also run when variant changes (for dynamic loading)
if (typeof window.variantChangeCallback === 'undefined') {
  window.variantChangeCallback = function() {
    const colorInputs = document.querySelectorAll('.product-form__input input[type="radio"]');
    colorInputs.forEach(function(input) {
      const label = input.nextElementSibling;
      if (label && label.tagName === 'LABEL' && !label.hasAttribute('data-color')) {
        const colorName = label.textContent.trim();
        const parentFieldset = input.closest('fieldset');
        const legend = parentFieldset ? parentFieldset.querySelector('legend') : null;
        const isColorOption = legend && (
          legend.textContent.toLowerCase().includes('color') ||
          legend.textContent.toLowerCase().includes('colour')
        );
        if (isColorOption && colorName) {
          label.setAttribute('data-color', colorName);
        }
      }
    });
  };
}
